// Angular dependencies
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Imports modules
import { PageCreepLevelComponent } from './page-creep-level.component';

const routes: Routes = [{
  path: 'creep/levels',
  pathMatch: 'full',
  component: PageCreepLevelComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PageCreepLevelRouterModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/page-creep-level.router.ts